module.exports = __webpack_public_path__ + "static/img/8.6836e200.png";